export default defineNuxtPlugin(({ $config }) => {
  const { public: publicConfig } = $config;

  if (publicConfig.redFastLabs) {
    useScript({
      src: publicConfig.redFastLabs,
      defer: true,
    });
  }

  if (publicConfig.oneTrust) {
    useScript({
      src: publicConfig.oneTrust,
      "data-document-language": true,
      "data-domain-script": publicConfig.oneTrustDataDomain,
    });
  }

  useScript({
    src: "/scripts3/datalayer.js?2",
    defer: true,
  });

  useScript({
    src: "/scripts3/newrelic.js",
    defer: true,
  });

  useScript({
    src: "/scripts3/onetrust.js?2",
  });

  if (publicConfig.rpiScriptSrc) {
    useScript({
      src: publicConfig.rpiScriptSrc,
      defer: true,
      fetchpriority: "high",
    });
  }
});
